import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UserSessionService } from '../../shared/services/user-session.service';

@Component({
  selector: 'app-admin-bar',
  templateUrl: './admin-bar.component.html',
  styleUrls: ['./admin-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AngularSvgIconModule]
})
export class AdminBarComponent {
  private readonly router = inject(Router);
  private readonly userSessionService = inject(UserSessionService);

  public readonly isAdmin = computed(() => this.userSessionService.userSession?.isAdmin ?? false);

  navigateToSites(): void {
    this.router.navigate(['/admin-settings']);
  }

  navigateToHome(): void {
    this.router.navigate(['/']);
  }
}
